import { ServerResponse } from "../../types/baseType";
import { Operation } from "../../store/reducers/references/operations";

const httpClient = require('@infobis/api-module').default;

export default class OperationsService {
    static async fetch(): Promise<ServerResponse<Operation[]>> {
        const request = {
            url: `/operations`,
            params: {
                method: "GET",
            },
            authorize: false,
        };
        return httpClient.makeRequest(request) as ServerResponse<Operation[]>
    }
}